import React, {Component} from 'react'

class UploadFileField extends Component {
  onFileChange(e, field) {
    let value = e.target.files[0];

    if (value && value.size > 4194304) {
      alert('Maximum image size is 4MB.');
      e.target.value = null;
      return;
    }

    this.props.validate(value, field);
    this.props.onSelectedImage(true);
  }

  render() {
    let field = this.props.field;

    let hasErrors = field.errors.length > 0 ? true : false

    return (
      <div className={hasErrors ? 'form-group text-danger' : 'form-group'}>
        <label className="form-control-label">{field.rules.title}</label>
        <div className="input-group">
          <input type="file" name={field.name} accept=".jpg,.jpeg,.png,.gif" onChange={e => this.onFileChange(e, field)} />
        </div>
        {field.errors.map((error, i) => (
          <div key={i} className="form-text text-danger">
            {error}
          </div>
        ))}
      </div>
    )
  }
}

export default (UploadFileField)
